<template>
  <div
    class="image-block"
    :class="styleClasses"
    :style="styles"
    v-editable="blok"
  >
    <a
      v-if="rawLink"
      :href="formattedLink"
      :target="linkTarget"
      aria-label="Image link"
    >
      <img
        v-if="!rawLink"
        :src="imageSrc"
        data-sizes="auto"
        :data-src="imageDatasrc"
        :data-srcset="imageDataset"
        class="lazyload"
        alt="Article image"
      />
    </a>
    <img
      v-if="!rawLink"
      :src="imageSrc"
      data-sizes="auto"
      :data-src="imageDatasrc"
      :data-srcset="imageDataset"
      class="lazyload"
      alt="Article image"
    />
    <figcaption v-if="blok.caption" v-html="captionHtml"></figcaption>
  </div>
</template>

<script>
import Marked from 'marked'

export default {
  props: ['blok'],
  computed: {
    captionHtml() {
      return this.blok.caption ? Marked(this.blok.caption) : ''
    },
    styles() {
      if (!['left', 'center', 'right'].includes(this.blok.align)) return {}
      return { 'text-align': this.blok.align }
    },
    styleClasses() {
      let appliedClasses = this.blok.style || ''
      if (this.blok.no_upscale) {
        appliedClasses += ' no-upscale'
      }
      return appliedClasses
    },
    rawLink() {
      const linkId = _.get(this, 'blok.link.id')
      if (this.linkType !== 'url' && !linkId) {
        return ''
      }
      return _.get(this, 'blok.link.cached_url') || _.get(this, 'blok.link.url')
    },
    linkType() {
      return _.get(this, 'blok.link.linktype')
    },
    formattedLink() {
      let link = this.rawLink
      if (this.linkType !== 'url') {
        link = '/' + link
      }
      return link
    },
    linkTarget() {
      const target = this.blok.target
      if (target === 'blank') {
        return '_blank'
      }
      return '_self'
    },
    imageDataset() {
      const image1 = this.resizeImage('200x0')
      const image2 = this.resizeImage('300x0')
      const image3 = this.resizeImage('600x0')
      const image4 = this.resizeImage('900x0')
      return `${image1} 200w, ${image2} 300w, ${image3} 600w, ${image4} 900w`
    },
    imageDatasrc() {
      return this.resizeImage('300x0')
    },
    imageSrc() {
      return this.resizeImage('100x0')
    },
  },
  methods: {
    resizeImage(option) {
      const image = this.blok.image
      const imageService = 'https://img2.storyblok.com/'
      const path = image.replace('//a.storyblok.com', '')
      return imageService + option + path
    },
  },
}
</script>

<style lang="scss" scoped>
.main-image-block {
  border: 2px solid $primary-border;
}
.secondary-image-block {
  border: 2px solid $secondary-border;
}
.image-block {
  img {
    width: 100%;
  }
  &.no-upscale img {
    max-width: 100%;
    width: auto;
  }
}
</style>
